<template>
  <div class="countdown-container" :class="`countdown-container-${countdownType}`">
    <template v-if="!(hiddenZero && formattedHours === '00')">
      <div class="countdown-item">{{ formattedHours }}</div>
      <div class="countdown-symbol">{{ unitType === 1 ? ':' : '时' }}</div>
    </template>
    <div class="countdown-item">{{ formattedMinutes }}</div>
    <div class="countdown-symbol">{{ unitType === 1 ? ':' : '分' }}</div>
    <div class="countdown-item">{{ formattedSeconds }}</div>
    <div v-if="unitType === 2" class="countdown-symbol">{{ unitType === 2 ? '秒' : '' }}</div>
  </div>
</template>

<script>
import { mapMutations, mapActions } from 'vuex';
import * as types from '../store/me/mutations-types';
export default {
  props: {
    startTime: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: true,
    },
    currentTime: {
      type: String,
      required: true,
    },
    countdownType: {
      type: String,
      default: 'normal',
    },
    unitType: {
      type: Number,
      default: 1, // 1是 : 2是汉字
    },
    hiddenZero: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      remainingTime: this.calculateRemainingTime(),
      formattedHours: '',
      formattedMinutes: '',
      formattedSeconds: '',
    };
  },
  watch: {
    currentTime() {
      this.remainingTime = this.calculateRemainingTime();
      this.updateCountdown();
    },
  },
  methods: {
    ...mapMutations('me', ['SET_COUNTDOWN_STATE']),
    ...mapActions('me', ['getPurchaseRecordData']),
    calculateRemainingTime() {
      const startTimestamp = new Date(this.startTime).getTime();
      const currentTimestamp = new Date(this.currentTime).getTime();
      const elapsedMilliseconds = currentTimestamp - startTimestamp;
      const remainingMilliseconds = this.duration * 1000 - elapsedMilliseconds;

      return remainingMilliseconds > 0 ? remainingMilliseconds : 0;
    },
    updateCountdown() {
      if (this.remainingTime > 0) {
        const hours = Math.floor(this.remainingTime / (1000 * 60 * 60));
        const minutes = Math.floor((this.remainingTime % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((this.remainingTime % (1000 * 60)) / 1000);

        this.formattedHours = this.formatTime(hours);
        this.formattedMinutes = this.formatTime(minutes);
        this.formattedSeconds = this.formatTime(seconds);

        this.remainingTime -= 1000; // 每秒递减1000毫秒
      } else {
        this.getPurchaseRecordData();
        this.$emit('countdownOver');
        this[types.SET_COUNTDOWN_STATE] = false;
        clearInterval(this.timer);
      }
    },
    formatTime(unit) {
      return unit.toString().padStart(2, '0');
    },
    async resetTimer() {
      if (document.visibilityState === 'hidden') {
        clearInterval(this.timer);
        this.timer = null;
      } else {
        await this.getPurchaseRecordData();
        if (!this.timer) this.timer = setInterval(this.updateCountdown, 1000);
      }
    },
  },
  mounted() {
    this.updateCountdown(); // 初始化倒计时文本
    this.timer = setInterval(this.updateCountdown, 1000); // 每秒钟更新一次
    document.addEventListener('visibilitychange', this.resetTimer);
  },
  beforeDestroy() {
    clearInterval(this.timer); // 清除定时器
    document.removeEventListener('visibilitychange', this.resetTimer);
  },
};
</script>
<style lang="scss" scoped>
.countdown-container {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #fff;
  font-weight: 500;
  &-white,
  &-pink {
    .countdown-item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 26px;
      height: 22px;
      border-radius: 4px;
      background-color: #ff7557;
      color: #fff;
    }
    .countdown-symbol {
      margin: 0 4px;
      color: #ff7557;
    }
  }
  &-pink {
    .countdown-item {
      background-color: #fff;
      color: #ff7557;
    }
    .countdown-symbol {
      color: #fff;
    }
  }
}
</style>
